import baseRequest from '../baseRequest';
import AppConfig from '../../app/config/AppConfig';

class SetTravelInsurancePopupAgreement extends baseRequest
{
    constructor(updateState) {
        super();
        this.name = 'SetTravelInsurancePopupAgreement';
        this.dispatch = null;
        this.response = null;
        this.config = new AppConfig();
        this.updateState = updateState;
    }

    execute(dispatch) {
        this.dispatch = dispatch;
        this.call(this.config.api.requests.setTravelInsurancePopupAgreement);
    }

    onSuccess() {
        this.updateState(this.response.data);
    }
}

export default SetTravelInsurancePopupAgreement;
